import type { FeatureFlag, FeatureFlagStatus } from '@pflegenavi/shared/api';
import { useContext } from 'react';
import { FeatureFlagDevContext } from './FeatureFlagDevContext';

export type UseFeatureFlagBase = (
  featureFlag: FeatureFlag
) => FeatureFlagStatus;

/**
 * Return the feature flag including the ones that are currently set in the dev tools
 *
 * @example
 * const status = useFeatureFlagDev(FeatureFlag.CoinList, useFeatureFlagBase);
 */
export const useFeatureFlagDev = (
  featureFlag: FeatureFlag,
  useFeatureFlagBase: UseFeatureFlagBase
): FeatureFlagStatus => {
  const { data } = useContext(FeatureFlagDevContext);

  const status = data.get(featureFlag);

  const backendFeatureFlag = useFeatureFlagBase(featureFlag);

  if (status === undefined) {
    return backendFeatureFlag;
  }

  return status;
};
